/**
 * IneaContext — lets any page tell the floating Inea what it's currently
 * showing (e.g. an open prospect in the pipeline drawer). The bubble passes
 * this to /inea/chat so Inea can reason about "this prospect".
 */
import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

interface IneaContextValue {
  openProspectId: string | null;
  setOpenProspectId: (id: string | null) => void;
}

const Ctx = createContext<IneaContextValue>({
  openProspectId: null,
  setOpenProspectId: () => undefined,
});

export function IneaContextProvider({ children }: { children: ReactNode }) {
  const [openProspectId, setOpenProspectId] = useState<string | null>(null);
  const value = useMemo(() => ({ openProspectId, setOpenProspectId }), [openProspectId]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useIneaContext(): IneaContextValue {
  return useContext(Ctx);
}
